import {marketTime} from "../js/util/DateTimeUtil";

export interface VirtualPageView {
    title: string;
    url: string;
    timestamp?: string;
}

export const VIRTUAL_PAGE_VIEWS = {
    FirstTimeDemo: {
        title: "Demo",
        url: "/tradefloor-demo"
    },
    ReturningDemo: {
        title: "Demo returning",
        url: "/tradefloor-demo-returning"
    },
    RegisterPersonalInformation: {
        title: "Register Step 2",
        url: "/register-step2"
    },
    RegisterTerms: {
        title: "Register Step 3",
        url: "/register-step3"
    },
    PlaceOrder: {
        title: "Trade Submitted",
        url: "/trade-submitted",
        timestamp:  marketTime().format("DD/MM/YYYY, HH:mm")
    },
  };
